import Vue from 'vue';
import { HTTP_DELETE, HTTP_GET, HTTP_POST, HTTP_PUT } from '../const';
import {
  ADD_WHITELIST_WALLET,
  DELETE_WHITELIST_WALLET,
  EDIT_ACCUMULATION_SETTINGS,
  LOAD_ACCUMULATION_SETTINGS,
  LOAD_AML_BALANCE,
  LOAD_SETTINGS,
} from '../const/settings';

export default {
  namespaced: true,
  state: {
    rowColors: [
      '#ffe6d7',
      '#ddffdf',
      '#d7e8ff',
      '#ffd3f8',
      '#c2f3ed',
      '#f3c2c7',
      '#e2e2c8',
      '#f8e2db',
      '#e6ddf3',
      '#b3bbb4',
    ],
    defaults: {
      roles: {
        superadmin: 'Суперадмин',
        support: 'Поддержка',
        service: 'Служебный',
        client: 'Клиент',
      },
    },
  },
  getters: {
    roles: (state) => state.defaults.roles,
  },
  actions: {
    [LOAD_SETTINGS]: async ({ dispatch }) => {
      return await dispatch(
        HTTP_GET,
        {
          method: LOAD_SETTINGS,
          namespace: 'settings',
          no_commit: true,
        },
        { root: true },
      );
    },
    [LOAD_AML_BALANCE]: async ({ dispatch }) => {
      return await dispatch(
        HTTP_GET,
        {
          method: LOAD_AML_BALANCE,
          namespace: 'settings',
          no_commit: true,
        },
        { root: true },
      );
    },
    [LOAD_ACCUMULATION_SETTINGS]: async ({ dispatch }) => {
      return await dispatch(
        HTTP_GET,
        {
          method: LOAD_ACCUMULATION_SETTINGS,
          namespace: 'settings',
          no_commit: true,
        },
        { root: true },
      );
    },
    [EDIT_ACCUMULATION_SETTINGS]: async ({ dispatch }, data) => {
      return await dispatch(
        HTTP_PUT,
        {
          method: EDIT_ACCUMULATION_SETTINGS,
          namespace: 'settings',
          no_commit: true,
          body: data,
        },
        { root: true },
      );
    },
    [ADD_WHITELIST_WALLET]: async ({ dispatch }, { blockchain, address, token_2fa }) => {
      return await dispatch(
        HTTP_POST,
        {
          method: ADD_WHITELIST_WALLET,
          namespace: 'settings',
          no_commit: true,
          body: { blockchain, address, token_2fa },
        },
        { root: true },
      );
    },
    [DELETE_WHITELIST_WALLET]: async ({ dispatch }, { blockchain, address, token_2fa }) => {
      return await dispatch(
        HTTP_DELETE,
        {
          method: DELETE_WHITELIST_WALLET,
          namespace: 'settings',
          no_commit: true,
          body: { blockchain, address, token_2fa },
        },
        { root: true },
      );
    },
  },
  mutations: {
    [LOAD_SETTINGS]: (state, { data }) => {
      for (const settingName of Object.keys(data)) {
        Vue.set(state, settingName, data[settingName]);
      }
    },
  },
};
